import { MSym } from '@storeo/ui';
import { DemoBanner } from '../components/lumina/Placeholder';

const LINKS = [
  {
    icon: 'headphones',
    name: 'Black Friday — Fone TWS VIP',
    url: 'sualoja/go/fones-vip',
    channel: 'TikTok Ads & Influencers',
    stats: [
      ['Cliques', '42.180'],
      ['Checkouts', '6.840'],
      ['Vendas pagas', '2.310'],
      ['Conversão', '5.5%'],
      ['Receita', 'R$ 89.400'],
    ],
  },
  {
    icon: 'fitness_center',
    name: 'Bio do Instagram — Whey Isolado',
    url: 'sualoja/go/whey',
    channel: 'Instagram Bio Link',
    stats: [
      ['Cliques', '28.400'],
      ['Checkouts', '4.120'],
      ['Vendas pagas', '1.980'],
      ['Conversão', '7.0%'],
      ['Receita', 'R$ 61.300'],
    ],
  },
  {
    icon: 'send',
    name: 'Grupo VIP Telegram — Mentoria',
    url: 'sualoja/go/mentoria',
    channel: 'Telegram Broadcast',
    stats: [
      ['Cliques', '9.870'],
      ['Checkouts', '2.240'],
      ['Vendas pagas', '1.410'],
      ['Conversão', '14.3%'],
      ['Receita', 'R$ 43.600'],
    ],
  },
];

/** Links de Venda — redesign Lumina (docs/prototype/storeo_links_de_venda_smart_links).
 *  Sem backend ainda — toda a tela é mockup fiel ao protótipo. */
export function Links() {
  return (
    <div className="lumina flex flex-col gap-space-lg text-on-surface">
      <div className="relative overflow-hidden rounded-2xl bg-linear-to-r from-surface-container-low via-surface-container to-surface-container-high p-space-xl shadow-md">
        <div className="absolute -right-20 -top-20 w-80 h-80 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -left-10 -bottom-10 w-60 h-60 bg-secondary/10 rounded-full blur-2xl pointer-events-none" />
        <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-space-lg">
          <div className="max-w-3xl flex flex-col gap-space-xs">
            <div className="flex items-center gap-space-xs">
              <span className="px-space-xs py-space-3xs rounded-full bg-primary/20 text-primary font-label-sm text-label-sm uppercase tracking-wider flex items-center gap-space-3xs">
                <MSym name="bolt" className="text-[14px]" /> Checkout de alta velocidade
              </span>
              <span className="px-space-xs py-space-3xs rounded-full bg-secondary-container/20 text-secondary font-label-sm text-label-sm flex items-center gap-space-3xs">
                <span className="w-1.5 h-1.5 rounded-full bg-secondary animate-ping" /> PIX 1-clique
              </span>
            </div>
            <h1 className="font-headline-lg text-headline-lg text-on-surface tracking-tight">Links de Venda &amp; Checkout Direto</h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant max-w-2xl">
              Crie links rápidos para campanhas no TikTok, bio do Instagram, WhatsApp e Telegram — o cliente vai direto pro
              checkout, sem carregar a loja inteira.
            </p>
          </div>
          <button className="px-space-lg py-space-sm rounded-xl bg-linear-to-r from-primary-container to-inverse-primary text-on-primary font-label-lg text-label-lg shadow-lg flex items-center gap-space-xs self-start">
            <MSym name="add_link" className="text-[20px]" /> Criar link de venda
          </button>
        </div>
      </div>

      <DemoBanner />

      {/* 4 metric cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-space-md">
        {[
          { label: 'Total de cliques', value: '84.920', tag: '+18.4%', foot: '94% de canais mobile', icon: 'ads_click' },
          { label: 'Vendas via links', value: 'R$ 194.300', tag: '+32.1%', foot: '82% liquidados via PIX', icon: 'payments' },
          { label: 'Conversão média', value: '11.2%', tag: '3.4x loja padrão', foot: 'Drop-off em checkout: 14%', icon: 'query_stats' },
          { label: 'Tempo médio de compra', value: '22 seg', tag: 'Instantâneo', foot: 'Autofill de CPF e PIX QR', icon: 'timer' },
        ].map((c) => (
          <div key={c.label} className="p-space-lg rounded-xl bg-surface-container-low relative overflow-hidden group hover:bg-surface-container transition-all shadow-md">
            <div className="flex items-center justify-between mb-space-sm">
              <span className="font-label-sm text-label-sm uppercase tracking-wider text-on-surface-variant">{c.label}</span>
              <div className="w-8 h-8 rounded-lg bg-surface-container-highest flex items-center justify-center text-primary group-hover:scale-110 transition-transform">
                <MSym name={c.icon} className="text-[18px]" />
              </div>
            </div>
            <div className="flex items-baseline justify-between">
              <span className="font-metric-stat text-metric-stat text-on-surface tracking-tight">{c.value}</span>
              <span className="px-space-xs py-space-3xs rounded-full bg-secondary-container/20 text-secondary font-label-sm text-label-sm">{c.tag}</span>
            </div>
            <div className="mt-space-md font-body-sm text-body-sm text-on-surface-variant">{c.foot}</div>
          </div>
        ))}
      </div>

      {/* active links */}
      <div className="flex flex-col gap-space-md">
        <div className="flex items-center gap-space-xs">
          <h2 className="font-headline-md text-headline-md text-on-surface">Links ativos</h2>
          <span className="px-space-xs py-space-3xs rounded-md bg-surface-container-high text-on-surface-variant font-label-sm text-label-sm">
            {LINKS.length} rodando
          </span>
        </div>
        <div className="flex flex-col gap-space-sm">
          {LINKS.map((l) => (
            <div key={l.name} className="p-space-lg rounded-xl bg-surface-container-low hover:bg-surface-container transition-all flex flex-col gap-space-md">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-space-sm">
                <div className="flex items-start sm:items-center gap-space-sm">
                  <div className="w-10 h-10 rounded-xl bg-primary/20 text-primary flex items-center justify-center shrink-0">
                    <MSym name={l.icon} className="text-[24px]" />
                  </div>
                  <div className="flex flex-col">
                    <div className="flex items-center gap-space-xs flex-wrap">
                      <span className="font-headline-sm text-headline-sm text-on-surface">{l.name}</span>
                      <span className="px-space-xs py-space-3xs rounded-full bg-secondary-container/20 text-secondary font-label-sm text-label-sm flex items-center gap-space-3xs">
                        <span className="w-1.5 h-1.5 rounded-full bg-secondary" /> Ativo
                      </span>
                    </div>
                    <div className="flex items-center gap-space-xs text-on-surface-variant font-body-sm text-body-sm mt-space-3xs">
                      <span className="text-tertiary font-label-md text-label-md">{l.url}</span>
                      <MSym name="content_copy" className="text-[16px]" />
                      <span>•</span>
                      <span>
                        Canal: <strong>{l.channel}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-space-xs self-end sm:self-center">
                  <button className="px-space-sm py-space-2xs rounded-lg bg-surface-container-high text-on-surface font-label-sm text-label-sm flex items-center gap-space-3xs">
                    <MSym name="edit" className="text-[16px]" /> Editar
                  </button>
                  <button className="px-space-sm py-space-2xs rounded-lg bg-surface-container-high text-on-surface font-label-sm text-label-sm flex items-center gap-space-3xs">
                    <MSym name="qr_code_2" className="text-[16px]" /> QR
                  </button>
                </div>
              </div>
              <div className="p-space-sm rounded-lg bg-surface-container/60 grid grid-cols-2 sm:grid-cols-5 gap-space-sm text-center">
                {l.stats.map(([k, v]) => (
                  <div key={k} className="flex flex-col">
                    <span className="font-label-sm text-label-sm text-on-surface-variant">{k}</span>
                    <span className="font-headline-sm text-headline-sm text-on-surface">{v}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
